import { Component, Input, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import {
  Damages,
} from 'remarketing-angular-library';
import { UntypedFormArray } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';
import { SaComponent, CurrencyFormatService } from 'smartauction-frontend-micro-library';
import { checkMobile } from '../../../../../shared/utils/util';
import { CdkTableModule } from '@angular/cdk/table';
import { TableModule } from 'remarketing-ui-components-lib';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-report-damages-table',
    templateUrl: './report-damages-table.component.html',
    styleUrls: ['./report-damages-table.component.scss'],
    imports: [
        TableModule,
        CdkTableModule,
        NgClass
    ]
})
export class ReportDamagesTableComponent extends SaComponent implements OnInit {
  @Input() damages: Damages[] = [];
  @Input() heading: string;
  translations = {
    tableHeaderType: '',
    tableHeaderLocation: '',
    tableHeaderExcessWear: '',
    tableHeaderEstimatedCost: '',
    tableHeaderDescription: '',
    labelDamages: ''
  };


  vehicleDataFormArray = new UntypedFormArray([]);

  constructor(
    private readonly translocoService: TranslocoService,
    private readonly currencyFormatService: CurrencyFormatService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  getTranslations(): void {
    const keyParams = {
      'reports': {}
    };

    this.translocoService.selectTranslateObject(keyParams).pipe(takeUntil(this.destroyed$)).subscribe(translate => {
      this.translations.tableHeaderType = translate[0].reportContent.tableHeaderType;
      this.translations.tableHeaderLocation = translate[0].reportContent.tableHeaderLocation;
      this.translations.tableHeaderExcessWear = translate[0].reportContent.tableHeaderExcessWear;
      this.translations.tableHeaderEstimatedCost = translate[0].reportContent.tableHeaderEstimatedCost;
      this.translations.tableHeaderDescription = translate[0].reportContent.tableHeaderDescription;
      this.translations.labelDamages = translate[0].reportContent.labelDamages;
    });
  }

  get isMobile() {
    return checkMobile();
  }

  getExcessWear(damages) {
    switch(damages.chargeable) {
    case(true):
      return 'Yes';
    case(false):
      return 'No';
    default:
      return 'N/A';
    }
  }

  formatCurrency(currency) {
    return this.currencyFormatService.formatCurrency(currency, false);
  }

  get columns() {
    return [
      'index',
      'type',
      'location',
      'excessWear',
      'estimatedCost',
      'description'
    ];
  }
}
